// import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
// import {createLogger} from 'redux-logger';
// import penderMiddleware from 'redux-pender';
// import * as modules from './modules';

// const logger = createLogger();
// const reducers = combineReducers(modules);
// const middlewares = [penderMiddleware()];

// // 개발 모드일 때만 Redux Devtools 적용
// const isDev = process.env.NODE_ENV === 'development';
// const devtools = isDev && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
// const composeEnhancers = devtools || compose;

// // preloadedState는 추후 서버사이드 렌더링이 되었을 때 전달 받는 초기 상태입니다.
// const configure = (preloadedState) => createStore(reducers, preloadedState, composeEnhancers(
//   applyMiddleware(logger, ...middlewares)
// ));

// export default configure;
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { createLogger } from 'redux-logger';
import penderMiddleware from 'redux-pender';
import * as modules from './modules';

const reducers = combineReducers(modules);
const middlewares = [penderMiddleware()];

const isDev = process.env.NODE_ENV === 'development';

// 🔥 개발 모드에서만 logger 추가
if (isDev) {
  const logger = createLogger({
    collapsed: true, // 로그 접어서 보기 (선택)
  });
  // middlewares.push(logger);
}

// Redux DevTools
const composeEnhancers =
  (isDev && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const configure = (preloadedState) =>
  createStore(
    reducers,
    preloadedState,
    composeEnhancers(
      applyMiddleware(...middlewares)
    )
  );

export default configure;
